import { PetParent, PetParentAnimal } from '../../types/PetParent';
import { getPrimaryAnimal } from './Home/utils';
import getPreSurrenderAnimal from './PreSurrender/eligibility';

export type HubAudience = 'adopter' | 'preSurrender' | 'foster';

/**
 * The primary animal when the parent is a foster (a Foster animal at a Plus
 * AWO), else null.
 */
export function getFosterAnimal(petParent: PetParent | null | undefined): PetParentAnimal | null {
  if (petParent?.awo?.membershipType !== 'Plus') return null;
  const primary = getPrimaryAnimal(petParent);
  return primary?.careType === 'Foster' ? primary : null;
}

/** Which Hub experience a pet parent gets. Foster wins over pre-surrender. */
export default function getHubAudience(petParent: PetParent | null | undefined): HubAudience {
  if (getFosterAnimal(petParent)) return 'foster';
  if (getPreSurrenderAnimal(petParent)) return 'preSurrender';
  return 'adopter';
}
